module.exports = __webpack_public_path__ + "img/about2.e306443e.jpg";